<div class="main-wrapper">
  <ng-container *ngIf="loader">
    <app-loader></app-loader>
  </ng-container>
  <!-- partial:sidebar -->
  <ng-container *ngIf="!navbarLoading">
    <app-sidebar></app-sidebar>
  </ng-container>
  <!-- partial -->

  <div class="page-wrapper">
    <!-- partial:navbar -->
    <app-navbar (loader)="navbarLoader($event)"></app-navbar>
    <!-- partial -->

    <div class="page-content" *ngIf="!navbarLoading">
      <!-- Spinner for lazyload modules -->
      <div *ngIf="isLoading" class="spinner-wrapper">
        <div class="spinner">Loading...</div>
      </div>

      <div contentAnimate *ngIf="!isLoading">
        <router-outlet> </router-outlet>
      </div>
    </div>

    <!-- partial:footer -->
    <app-footer></app-footer>
    <!-- partial -->
  </div>
</div>
